import React from 'react';
import Jackpot from '../../../assets/icons/svg/Jackpot';
import Coins from '../../../assets/icons/svg/Coins';
import Players from '../../../assets/icons/svg/AvatarFilled';
import Live from '../../../assets/icons/svg/Live';
import Dealers from '../../../assets/icons/svg/DkFlag';
import Date from '../../../assets/icons/svg/Calender';
import LiveCasino from '../../../assets/icons/svg/BlackJack';
import { Icon, IconSizes } from '../Icon/Icon';
import { Paragraph } from '../Paragraph/Paragraph';
import { fontSizes, fontWeights } from '../../helpers/tileHelper';

export interface TilePillProps {
  className?: string;
  text: string;
  additionalInfo?: string;
  icon?:
  | 'bid'
  | 'players'
  | 'dealers'
  | 'live-games'
  | 'jackpot'
  | 'date'
  | 'live-casino';
  iconSize?: keyof typeof IconSizes;
  ariaLabel?: string;
  background?: keyof typeof backgroundStyle;
  textSize?: keyof typeof fontSizes;
  textWeight?: keyof typeof fontWeights;
}

const backgroundStyle = {
  'light-grey': 'bg-neutrals-grey-200/25',
  grey: 'bg-neutrals-grey-950/20',
  'dark-grey': 'bg-neutrals-grey-950/60',
  purple: 'bg-purple-primary/80',
  transparent: 'bg-transparent',
};

function getIcon(icon: TilePillProps['icon']) {
  switch (icon) {
  case 'bid':
    return <Coins />;
  case 'players':
    return <Players />;
  case 'dealers':
    return <Dealers />;
  case 'live-games':
    return <Live />;
  case 'jackpot':
    return <Jackpot />;
  case 'date':
    return <Date />;
  case 'live-casino':
    return <LiveCasino />;
  default:
    return <Jackpot />;
  }
}

export const TilePill = ({
  icon,
  iconSize,
  text,
  additionalInfo,
  textSize = 12,
  textWeight = 'medium',
  ariaLabel,
  background,
  className = '',
}: TilePillProps) => (
  <div
    className={`flex gap-4 backdrop-blur-[10px] md:backdrop-blur-none items-center px-8 py-4 rounded-100 w-fit min-w-0 lining-nums ${backgroundStyle[background ?? 'transparent']} ${className}`}
  >
    {icon && <Icon
      icon={getIcon(icon)}
      size={iconSize ?? 'small'}
      ariaLabel={ariaLabel}
    />}

    <Paragraph
      className='min-w-0'
      size={textSize}
      weight={textWeight}
      moreChildren={additionalInfo}>
      {text}
    </Paragraph>
  </div>
);
